import { useKnowledgeDocumentDataContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { useCallback } from 'react'
import styled from 'styled-components'

const DocumentTitle = styled.p`
  font-size: 0.875rem;
  line-height: 1.2;
  color: ${(props) => props.theme.forecast.defaultText};
`

const DocumentSubtitle = styled.p`
  font-size: 0.6875rem;
  color: ${(props) => props.theme.forecast.secondaryText};
  line-height: 1.2;
`

export type DocumentInfo = {
  title: string
  filename: string
  system: string
  vendor: string
  docType: string
  drawing: string
  revisionCode: string
  revisionDate: string
}

type DocumentHeaderTitleProps = {
  documentId: string
  customTitle?: string
}

export function DocumentHeaderTitle({
  documentId,
  customTitle,
}: DocumentHeaderTitleProps) {
  const { systemDocumentEntries } = useKnowledgeDocumentDataContext()

  const getDocumentInfo = useCallback(
    (documentId: string): DocumentInfo => {
      const entry = systemDocumentEntries.find(
        (entry) => entry.entry.id === documentId
      )?.entry

      return {
        title: entry?.data.document_title ?? '',
        filename: entry?.data.filename ?? '',
        system: entry?.data.system ?? '',
        vendor: entry?.data.vendor_name ?? '',
        docType: entry?.data.document_type ?? '',
        drawing: entry?.data.drawing_number ?? '',
        revisionCode: entry?.data.revision_code ?? '',
        revisionDate: entry?.data.revision_date ?? '',
      }
    },
    [systemDocumentEntries]
  )

  const getSubtitle = (documentInfo: DocumentInfo): string => {
    const subtitleParts = []
    if (documentInfo.revisionCode && documentInfo.revisionDate) {
      subtitleParts.push(
        `Revision ${documentInfo.revisionCode} (${documentInfo.revisionDate})`
      )
    } else if (documentInfo.revisionCode) {
      subtitleParts.push(`Revision ${documentInfo.revisionCode}`)
    } else if (documentInfo.revisionDate) {
      subtitleParts.push(`${documentInfo.revisionDate}`)
    }
    if (documentInfo.system) {
      subtitleParts.push(`${documentInfo.system}`)
    }
    if (documentInfo.vendor) {
      subtitleParts.push(`${documentInfo.vendor}`)
    }
    if (documentInfo.docType) {
      subtitleParts.push(`${documentInfo.docType}`)
    }
    if (documentInfo.drawing) {
      subtitleParts.push(`${documentInfo.drawing}`)
    }
    return subtitleParts.join(' •  ')
  }
  const documentInfo = getDocumentInfo(documentId)
  const showCustomTitle = customTitle && !documentId

  return (
    <div>
      <DocumentTitle>
        {showCustomTitle ? customTitle : documentInfo.title}
      </DocumentTitle>
      {!showCustomTitle && (
        <DocumentSubtitle>{getSubtitle(documentInfo)}</DocumentSubtitle>
      )}
    </div>
  )
}
